import { gql } from './gql'

/**
 * The shopper's own order history.
 *
 * Session-scoped by design: the customer is taken from `sessionUid` on the
 * server and never named by the client. The admin API's `getOrders` accepts a
 * `customerCode` filter; the user one deliberately does not, which is why this
 * can be called from a browser at all.
 *
 * Only what a history *list* renders is selected. Enriching each order with
 * priced, stock-checked products is what `order(id)` does when a card is
 * opened — doing it per row would re-price the whole page to draw four lines
 * of text.
 */
export const GET_ORDERS = gql`
  query GetOrders(
    $storefrontName: String!
    $sessionUid: ID!
    $pagination: PaginationInput
    $filter: SessionOrderFilterInput
  ) {
    getOrders(
      storefrontName: $storefrontName
      sessionUid: $sessionUid
      pagination: $pagination
      filter: $filter
    ) {
      orders {
        id
        status
        total
        sequence
        externalRefNumber
        createdAt
        items {
          quantity
        }
      }
      pagination {
        total
        totalPages
        pageNumber
        pageSize
        hasNextPage
      }
    }
  }
`
